import { FC, useContext } from "react";
import { Icon, Link } from "capitalrx-components-2.0/lib/general";
import { Shelf } from "capitalrx-components-2.0/lib/layout";
import { getThemeURL } from "@/utils";
import { ThemeSelectorContext } from "@/context";
import { URL, CLIENT_URL } from "@/constants/urls";
import { RgbColor } from "capitalrx-components-2.0/lib/general/Color";
import styles from "./BackLink.module.scss";


interface BackLinkProps {
  linkText: string;
}

function isValidPathKey(
  key: string,
): key is keyof typeof URL | keyof typeof CLIENT_URL {
  return key in URL || key in CLIENT_URL;
}


export const BackLink: FC<BackLinkProps> = ({ linkText }) => {
  const { primary_color } = useContext(ThemeSelectorContext);

  function parseColor(color: string): RgbColor | undefined {
    if (color.startsWith("#")) {
      const hex = color.replace("#", "");
      const match = hex.match(/.{1,2}/g);
      if (!match || match.length !== 3) return undefined;
      const [r, g, b] = match.map((x) => parseInt(x, 16));
      return { r, g, b, alpha: 1 };
    }

    const rgbMatch = color.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
    if (rgbMatch) {
      const [, r, g, b] = rgbMatch.map(Number);
      return { r, g, b, alpha: 1 };
    }

    const rgbaMatch = color.match(/^rgba\((\d+),\s*(\d+),\s*(\d+),\s*(\d*\.?\d+)\)$/);
    if (rgbaMatch) {
      const [, r, g, b, a] = rgbaMatch;
      return {
        r: parseInt(r),
        g: parseInt(g),
        b: parseInt(b),
        alpha: parseFloat(a),
      };
    }

    return undefined;
  }

  const rgbColor = parseColor(primary_color);
  const formattedLinkText = linkText.toUpperCase().replace(/\s+/g, "_");

  return (
    <Shelf spacing="mini">
      <Icon name="arrow-left" color={rgbColor} className={styles.linkHeight} />
      {isValidPathKey(formattedLinkText) ? (
        <Link to={getThemeURL(formattedLinkText)} className={styles.linkHeight} style={{ color: primary_color }}>
          {linkText}
        </Link>
      ) : (
        <Link to={getThemeURL("HOME")} className={styles.linkHeight} style={{ color: primary_color }}>
          Home
        </Link>
      )}
      <Shelf.Spacer />
    </Shelf>
  );
};
